import React, { useState } from 'react';

import CodeIcon from '@mui/icons-material/Code';
import { Button } from '@mui/material';

import type { ClaimCampaign } from '~/services/LuxLoyalty';

import ClaimCodesDialog from '../ClaimCodesDialog';

type CampaignProp = Pick<ClaimCampaign, 'id' | 'name' | 'validatorType'>;

interface Props {
  campaign: CampaignProp | null;
}

export default function ViewCodesButton({ campaign }: Props) {
  const [open, setOpen] = useState(false);

  const hasCode = campaign?.validatorType === 'PREGEN_CODE' || campaign?.validatorType === 'SHARED_CODE';

  if (!hasCode) {
    return null;
  }

  return (
    <>
      <Button size="small" startIcon={<CodeIcon />} onClick={() => setOpen(true)}>
        View Codes
      </Button>
      <ClaimCodesDialog open={open} campaign={campaign} onClose={() => setOpen(false)} />
    </>
  );
}
